import React from 'react';
import { SectionHeading } from './SectionHeading';
export function DifferenceSection() {
  return <section aria-labelledby="diferencia" className="bg-cream" data-id="element-61" data-mp="1b2h34cf0sw49">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-62" data-mp="1b4bqdxdrl0bi">
        <div className="grid gap-14 lg:grid-cols-[1.15fr_0.85fr] lg:items-center lg:gap-20" data-id="element-63" data-mp="1p2jhhoo4d7er">
          <div data-id="element-64" data-mp="1k1vtlbv6t6or">
            <SectionHeading align="left" title={<>
                  De estudiar inglés sin rumbo a tener{' '}
                  <span className="italic text-coral" data-id="element-66" data-mp="1y0bx6txr6h2o">todo organizado</span> frente a tus ojos.
                </>} data-id="element-65" data-mp="1k12m28oemd5k" />
            <div className="mt-7 max-w-reading space-y-5 text-lg leading-relaxed text-muted" data-id="element-67" data-mp="1tz0ez9h7ky4i">
              <p data-id="element-68" data-mp="27u2jbs6eqff7">
                Deja de saltar de un video a otro, guardar cientos de publicaciones o llenar cuadernos con reglas que
                después no recuerdas.
              </p>
              <p data-id="element-69" data-mp="2hob7y4sbho83">
                Ahora puedes tener una ruta visual desde los primeros conceptos del nivel A1 hasta estructuras,
                vocabulario y formas de expresión propias de los niveles C1 y C2.
              </p>
            </div>
          </div>

          <div className="divide-y divide-line border-t border-line lg:border-l lg:border-t-0 lg:pl-12" data-id="element-70" data-mp="2krjoheb7z2z4">
            {[{
            value: '+300',
            label: 'Mapas mentales visuales'
          }, {
            value: '6',
            label: 'Niveles de inglés'
          }, {
            value: 'A1 → C2',
            label: 'Una progresión completa'
          }].map(item => <div key={item.label} className="flex items-baseline gap-5 py-6 first:pt-8 lg:first:pt-0" data-id="element-71" data-mp="33p34j1w3hlv1">
                <span className="font-display text-4xl font-black leading-none text-coral sm:text-5xl" data-id="element-72" data-mp="38g2ypzdtxptu">
                  {item.value}
                </span>
                <span className="text-sm font-semibold uppercase tracking-[0.12em] text-ink" data-id="element-73" data-mp="3cjr4cciwibcg">{item.label}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}